import Typed from 'typed.js';

var typed = new Typed('.section--processes-examples__name-placeholder', {
    strings: [
        'New Employee Onboarding^1500',
        'Customer Support^1500',
        'Product Development^1500',
        'Financial Planning^1500',
        'Accounting Management^1500'
    ],
    loop: true,
    typeSpeed: 60,
    backSpeed: 20,
});
